<template>
  <div>
    <el-upload
      ref="uploadFile"
      class="upload-demo"
      drag
      :action="commonServer.uploadFile"
      :accept="uploadInfo.accept"
      :headers="{ Authorization: token }"
      :multiple="uploadInfo.multiple"
      :file-list="fileList"
      :on-progress="uploadProgress"
      :on-change="uploadChange"
      :on-success="uploadSuccess"
      :on-remove="uploadRemove"
      :on-preview="handlePreview"
      :on-error="uploadError"
      :before-upload="uploadBefore">
      <div class="el-upload__text">
          将文件拖到此处，或<em>点击上传</em>
          <p>{{uploadInfo.tip}}</p>
      </div>
    </el-upload>
    <!-- <el-progress :percentage="progress" /> -->
  </div>
</template>

<script>
import { commonServer } from '@/api/api'
export default {
  props: {
    uploadInfo: {
      type: Object
    }
  },
  data () {
    return {
      commonServer,
      progress: 0, // 上传进度
      fileInfo: {...this.uploadInfo},
      fileList: this.uploadInfo.fileList,
      token: window.localStorage.getItem('token')
    }
  },
  methods: {
    clearFormList () {
      this.fileList = this.uploadInfo.fileList
    },
    // 上传进度回调
    uploadProgress(event, file, fileList) {
      let index = 0
      // 只有fileList 跟file 里面的uid是唯一的互相对应的
      fileList.forEach((v, i) => {
        if (v.uid === file.uid) {
          index = i
        }
      })
      const progress = event.percent; // 获取上传进度百分比
      if (progress > 99) {
        let dom = document.getElementsByClassName('el-upload-list__item')[index]
        let progressText = dom.getElementsByClassName('el-progress__text')
        if (progressText && progressText.length) {
          progressText[0].style.opacity = 0
          progressText[0].innerText = '99%'
          progressText[0].style.opacity = 1
        }
      }
      // this.progress = Math.round((event.percent || 0));
    },
    uploadChange (file, fileList) {
      if (!this.uploadInfo.multiple) {
        if (fileList.length > 0) {
          this.fileList = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
        }
      }
    },
    /**
     * 上传结果处理
     * @function uploadSuccess
     * @param  {Object} response 上传返回结果
     */ 
    uploadSuccess (response, file) {
      if (response.success) {
        file.url = response.data.fileUrl
        this.$emit('uploadres', {response, file})
      } else {
        this.$message.error(response.message)
        this.$refs.uploadFile.uploadFiles.splice(this.$refs.uploadFile.uploadFiles.indexOf(file), 1);
      }
    },
    handlePreview (file) {
      window.open(file.url)
    },
    uploadRemove(file, fileList) {
      // 文件移除后的回调
      this.$emit('uploadres', {response: null, file: null});
    },
    /**
     * 上传前的判断
     * @function uploadBefore
     * @return {Boolean}
     */
    uploadBefore (file) {
      console.log('pppp')
      var fileSize = file.size / 1024 / 1024 < this.uploadInfo.fileSize;// 控制大小修改50的值即可
      if (!fileSize) {
        this.$message.error(`文件大小不能超过${this.uploadInfo.fileSize}MB`)
        this.fileList.splice(this.fileList.indexOf(file), 1);
        this.$refs.uploadFile.uploadFiles.splice(this.$refs.uploadFile.uploadFiles.indexOf(file), 1);
        return false;
      }
    },
    /**
     * 上传异常处理
     * @function uploadError
     * @param  {Object|String} err 上传异常信息
     */
    uploadError () {}
  }
}
</script>

<style lang='scss'>
.upload-demo {
  .el-upload {
    width: 100%;
  }
  /* 隐藏进度条 */
  // .el-upload-list .el-upload-list__item .el-progress--line {
  //   display: none;
  // }
  .el-upload-dragger {
    width: 100%;
    height: 120px;
  }
  .el-upload__text {
    padding-top: 35px;
    font-size: 16px;
    line-height: 28px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Uploadfile/index.vue